import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import AppAnimate from "../../components/AppAnimate";
import Grid from "@material-ui/core/Grid/Grid";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {connect, setStore} from "trim-redux";
import SellerGuidLine from "./components/SellerGuidLine";
import OrdersChart from "../../components/charts/OrdersChart";
import SellerAnalyticsShort from "./components/SellerAnalyticsShort";
import BestSellingProducts from "./components/BestSellingProducts";
import Alert from "@material-ui/lab/Alert/Alert";
import IconButton from "@material-ui/core/IconButton/IconButton";
import VolumeUpTwoToneIcon from '@material-ui/icons/VolumeUpTwoTone';
import VolumeOffTwoToneIcon from '@material-ui/icons/VolumeOffTwoTone';
import axios from "axios";
import {defaultVariabls} from "../../../config";
import {updateRedux} from "../../../config/Security";
import CircularProgress from "@material-ui/core/CircularProgress";
class SellerDashboard extends React.Component {
    classes = this.props.classes;
    state = {
        loading:false
    }
    changeSound(){
        this.setState({
            loading:true
        })
        let loginToken = localStorage.getItem('ACT');
        if (loginToken !== null) {
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };

            axios.get(`${defaultVariabls.url}/user/change-sound`, config)
                .then(async response => {
                    await updateRedux();
                    await this.setState({
                        loading: false
                    });
                }).catch(error => {
                    this.setState({
                        loading: false
                    });
                });
        } else {
            setStore({
                isAuth: false,
                user: null,
                loading: false
            });
            this.setState({
                loading: false
            });
        }
    }
    render(){
        let {user} = this.props;
        let {loading}= this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.dashboard}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12} style={{textAlign:"left"}}>
                        <IconButton
                            color={!!user.has_sound ? "secondary" : "primary"}
                            onClick={() => this.changeSound()}

                        >
                            {
                                !!loading ? <CircularProgress size={24} color="secondary"/>
                                    :
                                !!user.has_sound ?
                                    <VolumeUpTwoToneIcon/>
                                    :
                                    <VolumeOffTwoToneIcon/>
                            }
                        </IconButton>
                    </Grid>
                    <Grid item xs={12}>
                        <Alert severity="info" variant="filled" style={{fontSize:14}}>
                            {Translate.seller_dashboard_notic}
                        </Alert>
                    </Grid>
                    <Grid item xs={12}>
                           <SellerGuidLine/>
                    </Grid>
                    <Grid item xs={12}>
                        <SellerAnalyticsShort/>
                    </Grid>
                    <Grid item xs={12}>
                        <BestSellingProducts/>
                    </Grid>
                    <Grid item xs={12}>
                        <OrdersChart seller/>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}

const mstp = state => ({
    user: state.user,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(SellerDashboard)))));
